<button
    id="displayModeToolBtn"
    name="displayMode"
    type="button"
    class="btn btn-default nlr-icon-btn"
    [ngClass]="{active : isWidgetActive()}"
    [title]="getTooltip()"
    [disabled]="isWidgetDisabled()"
    (click)="toggleWidgetVisibility()">
    <i class="nlrp-icon nlrp-icon-display-mode"></i>
</button>
@if (isWidgetActive()) {
    <div
        id="displayMode"
        class="widget container-fluid well"
        cdkDrag
        [cdkDragConstrainPosition]="computeDragPosition"
        style="visibility: hidden"
        #widget>
        <form
            id="displayModeForm"
            name="displayModeForm"
            novalidate
            autocomplete="off"
            #displayModeForm="ngForm">
            <div
                class="col-xs-12 widget-header"
                cdkDragHandle>
                <span>{{widgetConfig.header}}</span>
                <div class="pull-right btn-group btn-group-xs">
                    <nlrp-help-link
                        [url]="helpLinkUrl"
                        [pageTitle]="helpPageTitle"></nlrp-help-link>
                    <i
                        class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                        [title]="widgetConfig.closeTooltip"
                        (click)="toggleWidgetVisibility()"></i>
                </div>
            </div>
            <div class="widget-content">
                <div class="col-xs-12">
                    <div class="display-mode">
                        <div class="col-xs-4">
                            <label>Mode</label>
                        </div>
                        <div class="col-xs-8">
                            @for (option of displayModeOptions; track option) {
                                <label
                                    class="nlr-radio"
                                    [title]="option.toolTip">
                                    <input
                                        type="radio"
                                        name="displayMode"
                                        id="{{option.id}}"
                                        [value]="option.value"
                                        [(ngModel)]="displayModeSelected"
                                        required />
                                    <span>{{option.displayValue}}</span>
                                </label>
                            }
                        </div>
                    </div>
                </div>
                <div class="col-xs-12">
                    <div class="display-mode-resolution">
                        <div class="col-xs-4">
                            <label>Resolution</label>
                        </div>
                        <div class="col-xs-8">
                            @for (option of displayModeResolutions; track option) {
                                <label
                                    class="nlr-radio"
                                    [title]="option.toolTip">
                                    <input
                                        type="radio"
                                        name="viewModeResolution"
                                        id="viewModeResolution"
                                        [value]="option.value"
                                        [(ngModel)]="displayModeResolutionSelected"
                                        [disabled]="isResolutionDisabled()"
                                        required />
                                    <span>{{option.displayValue}}</span>
                                </label>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 inline-bottom-buttons">
                <button
                    class="btn btn-default nlr-btn-sm"
                    title="Apply"
                    (click)="displayModeChanged()">
                    Apply
                </button>
                <button
                    class="btn btn-warning nlr-btn-sm"
                    title="Close"
                    (click)="toggleWidgetVisibility()">
                    Close
                </button>
            </div>
        </form>
    </div>
}
